<template>
  <v-navigation-drawer class="MobileNavDrawer" :mini-variant="mini" width="200" fixed permanent app>
    <div class="d-flex flex-column justify-space-between" style="height: 100%">
      <div class="my-4">
        <div class="logo_wrapper mb-5">
          <v-img v-if="mini"
            :src="require('./../../assets/logo-favicon.png')"
            contain
            class="logo"
            transition="scale-transition"
            @click="$router.push('/')"
            height="36"/>
          <v-img v-else
            :src="require('./../../assets/logo-strapline.svg')"
            contain
            class="logo"
            transition="scale-transition"
            @click="$router.push('/')"
            height="50"/>
        </div>
        <v-list nav dense>
          <v-list-item-group>
            <div v-for="item in menuItems" :key="item.name">
              <router-link :to="item.path" style="text-decoration: none; color: inherit;" active-class="router-link-active">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon v-text="item.meta.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                </v-list-item>
              </router-link>
            </div>
          </v-list-item-group>
        </v-list>
      </div>

      <div class="d-flex flex-row-reverse mx-2">
        <v-btn icon @click.stop="mini = !mini" elevation="2" fab small class="mb-2">
          <v-icon>mdi-chevron-{{mini ? 'right' : 'left'}}</v-icon>
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>


<script lang="ts">
import { vxm } from '@/store/index';
import { Vue, Component } from 'vue-property-decorator';
import DateHelper from "@/helpers/dateHelper";

@Component({})

export default class NavigationDrawer extends Vue {
  private mini = true;

  private get menuItems() { return vxm.GeneralStore.menuItems; }

}
</script>

<style>
  .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before {
    opacity: transparent;
  }
  a.router-link-active > .v-list-item::before {
    opacity: 0.12 !important
  }
  .v-list-item--link::before {
    opacity: 0 !important
  }
</style>
